import {combineReducers} from 'redux';

//reducers import
import AppReducer from "./AppReducer";
import AuthenticationReducer from "./AuthenticationReducer";
import ProfileReducer from "./ProfileReducer";
import SettingsReducer from "./SettingsReducer";
import ServicesReducer from "./ServicesReducer";
import AnnouncementsReducer from "./AnnouncementsReducer";

export default combineReducers({
    app: AppReducer,
    authentication: AuthenticationReducer,
    profile: ProfileReducer,
    settings: SettingsReducer,
    services: ServicesReducer,
    announcements: AnnouncementsReducer,
});